import { render, staticRenderFns } from "./ReceiveTab.vue?vue&type=template&id=830d554a&"
import script from "./ReceiveTab.vue?vue&type=script&lang=js&"
export * from "./ReceiveTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports